export const INQUIRE_TALENT = 'action/inquiry/talent/post'
export const INQUIRE_TALENT_CANCEL = 'action/inquiry/talent/delete'
export const INQUIRIES_FOR_TALENT = 'action/inquiry/talent/get'
export const INQUIRIES_FOR_COMPANY = 'action/inquiry/company/get'
export const ACCEPT_DECLINE = 'action/inquiry/accept-decline'
